import React from "react";
import GymNavigation from "../GymNavigation";
import Box from "components/UI/Box";
import NoteEdit from "./Edit";
import NoteView from "./View";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
class Notes extends React.Component {
  render() {
    return (
      <React.Fragment>
        <GymNavigation />
        <div style={style.wrapper}>
          <Box style={style.box} outline>
            {" "}
            <Router>
              <Switch>
                <Route
                  exact
                  path="/gyms/gym/notes/edit"
                  render={() => (
                    <NoteEdit {...this.props} gym_id={this.props.gym_id} />
                  )}
                />
                <Route path="" render={() => <NoteView {...this.props} />} />
              </Switch>
            </Router>
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default Notes;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "900px",
    padding: "100px 0px",
    marginBottom: "5px"
  },
  button: {
    width: "150px",
    height: "61px",
    fontSize: "16px"
  }
};
